export const AppHeaderHeight = 72;
export const AppHeaderHeightSm = 64;
export const AppFooterHeight = 32;
export const AppFooterHeightSm = 64;
export const AppMainContentPadding = 60;
export const InBuildAppHeaderHeight = 70;

export const InBuildAppSidebarHeaderHeight = 86;
export const MailAppContentHeaderHeight = 78;

export const TaskDetailHeaderHeight = 72;
export const TaskDetailAddCommentHeight = 72;

export const ChatSidebarHeaderHeight = 124;
export const ChatSidebarTabContainerHeight = 49;
export const ChatFooterHeight = 70;
export const CurrentAuthMethod = 'jwtAuth'; //jwtAuth,firebase,basic

export const getAppSidebarHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        InBuildAppSidebarHeaderHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    case 'sm':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        InBuildAppSidebarHeaderHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    default:
      return (
        AppHeaderHeight +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        InBuildAppSidebarHeaderHeight +
        (visibleAppFooter ? AppHeaderHeight : 0)
      );
  }
};

export const getMailContainerHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        MailAppContentHeaderHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    case 'sm':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        MailAppContentHeaderHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    default:
      return (
        AppHeaderHeight +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        MailAppContentHeaderHeight +
        (visibleAppFooter ? AppFooterHeight : 0)
      );
  }
};

export const getContactContainerHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return AppHeaderHeightSm + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeightSm : 0);
    case 'sm':
      return AppHeaderHeightSm + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeightSm : 0);
    default:
      return AppHeaderHeight + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeight : 0);
  }
};

export const getTaskListSidebarHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return AppHeaderHeightSm + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeightSm : 0);
    case 'sm':
      return AppHeaderHeightSm + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeightSm : 0);
    default:
      return AppHeaderHeight + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeight : 0);
  }
};

export const getTaskListContainerHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return AppHeaderHeightSm + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeightSm : 0);
    case 'sm':
      return AppHeaderHeightSm + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeightSm : 0);
    default:
      return AppHeaderHeight + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeight : 0);
  }
};

export const getTaskDetailContainerHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        TaskDetailHeaderHeight +
        TaskDetailAddCommentHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    case 'sm':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        TaskDetailHeaderHeight +
        TaskDetailAddCommentHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    default:
      return (
        AppHeaderHeight +
        AppMainContentPadding +
        TaskDetailHeaderHeight +
        TaskDetailAddCommentHeight +
        (visibleAppFooter ? AppFooterHeight : 0)
      );
  }
};

export const getChatSidebarHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        ChatSidebarHeaderHeight +
        ChatSidebarTabContainerHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    case 'sm':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        ChatSidebarHeaderHeight +
        ChatSidebarTabContainerHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    default:
      return (
        AppHeaderHeight +
        AppMainContentPadding +
        ChatSidebarHeaderHeight +
        ChatSidebarTabContainerHeight +
        (visibleAppFooter ? AppFooterHeight : 0)
      );
  }
};

export const getChatContainerHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        ChatFooterHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    case 'sm':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        ChatFooterHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    default:
      return (
        AppHeaderHeight +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        ChatFooterHeight +
        (visibleAppFooter ? AppFooterHeight : 0)
      );
  }
};

export const getWallHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return AppHeaderHeightSm + AppMainContentPadding + (visibleAppFooter ? AppFooterHeightSm : 0);
    case 'sm':
      return AppHeaderHeightSm + AppMainContentPadding + (visibleAppFooter ? AppFooterHeightSm : 0);
    default:
      return AppHeaderHeight + AppMainContentPadding + (visibleAppFooter ? AppFooterHeight : 0);
  }
};

export const countriesBIH = [
  { name: 'Bosna i Hercegovina', code: '000' },
  { name: 'Avganistan', code: '761' },
  { name: 'Olandska ostrva', code: '762' },
  { name: 'Albanija', code: '763' },
  { name: 'Alžir', code: '764' },
  { name: 'Američka Samoa', code: '765' },
  { name: 'Andora', code: '766' },
  { name: 'Angola', code: '767' },
  { name: 'Angvila', code: '768' },
  { name: 'Antarktika', code: '769' },
  { name: 'Antigva i Barbuda', code: '770' },
  { name: 'Argentina', code: '771' },
  { name: 'Jermenija', code: '772' },
  { name: 'Aruba', code: '773' },
  { name: 'Australija', code: '774' },
  { name: 'Austrija', code: '775' },
  { name: 'Azerbejdžan', code: '776' },
  { name: 'Bahami', code: '777' },
  { name: 'Bahrein', code: '778' },
  { name: 'Bangladeš', code: '779' },
  { name: 'Barbados', code: '780' },
  { name: 'Bjelorusija', code: '781' },
  { name: 'Belgija', code: '782' },
  { name: 'Belize', code: '783' },
  { name: 'Benin', code: '784' },
  { name: 'Bermuda', code: '785' },
  { name: 'Butan', code: '786' },
  { name: 'Bolivija', code: '787' },
  { name: 'Karipska Holandija', code: '788' },
  { name: 'Bocvana', code: '789' },
  { name: 'Ostrvo Buve', code: '790' },
  { name: 'Brazil', code: '791' },
  { name: 'Brunej', code: '793' },
  { name: 'Bugarska', code: '794' },
  { name: 'Burkina Faso', code: '795' },
  { name: 'Burundi', code: '796' },
  { name: 'Kape Verde', code: '797' },
  { name: 'Kambodža', code: '798' },
  { name: 'Kamerun', code: '799' },
  { name: 'Kanada', code: '800' },
  { name: 'Kajmanska Ostrva', code: '801' },
  { name: 'Centralnoafrička Republika', code: '802' },
  { name: 'Čad', code: '803' },
  { name: 'Čile', code: '804' },
  { name: 'Kina', code: '805' },
  { name: 'Božićna Ostrva', code: '806' },
  { name: 'Kolumbija', code: '808' },
  { name: 'Komorska Ostrva', code: '809' },
  { name: 'Kongo', code: '810' },
  { name: 'DR Kongo', code: '811' },
  { name: 'Kukova Ostrva', code: '812' },
  { name: 'Kostarika', code: '813' },
  { name: 'Obala Slonovače', code: '814' },
  { name: 'Hrvatska', code: '815' },
  { name: 'Kuba', code: '816' },
  { name: 'Kurasao', code: '817' },
  { name: 'Kipar', code: '818' },
  { name: 'Češka Republika', code: '819' },
  { name: 'Danska', code: '820' },
  { name: 'Džibuti', code: '821' },
  { name: 'Dominika&nbsp', code: '822' },
  { name: 'Dominikanska Republika', code: '823' },
  { name: 'Ekvador', code: '824' },
  { name: 'Egipat', code: '825' },
  { name: 'Salvador', code: '826' },
  { name: 'Ekvatorijalna Gvineja', code: '827' },
  { name: 'Eritreja', code: '828' },
  { name: 'Estonija', code: '829' },
  { name: 'Etiopija', code: '830' },
  { name: 'Foklandska Ostrva ( Malvini)', code: '831' },
  { name: 'Farska Ostrva', code: '832' },
  { name: 'Fidži', code: '833' },
  { name: 'Finska', code: '834' },
  { name: 'Francuska', code: '835' },
  { name: 'Francuska Gvajana', code: '836' },
  { name: 'Francuska Polinezija', code: '837' },
  { name: 'Francuske Južne Teritorije', code: '838' },
  { name: 'Gabon', code: '839' },
  { name: 'Gambija', code: '840' },
  { name: 'Gruzija', code: '841' },
  { name: 'Njemačka', code: '842' },
  { name: 'Gana', code: '843' },
  { name: 'Gibraltar', code: '844' },
  { name: 'Grčka', code: '845' },
  { name: 'Grenland', code: '846' },
  { name: 'Grenada', code: '847' },
  { name: 'Gvadalupe', code: '848' },
  { name: 'Guam', code: '849' },
  { name: 'Gvatemala', code: '850' },
  { name: 'Gernzi', code: '851' },
  { name: 'Gvineja', code: '852' },
  { name: 'Gvineja Bisao', code: '853' },
  { name: 'Gvajana', code: '854' },
  { name: 'Haiti', code: '855' },
  { name: 'Herd i arhipelag MekDonald', code: '856' },
  { name: 'Vatikan', code: '857' },
  { name: 'Honduras', code: '858' },
  { name: 'Hong Kong ( SAR Kina)', code: '859' },
  { name: 'Mađarska', code: '860' },
  { name: 'Island', code: '861' },
  { name: 'Indija', code: '862' },
  { name: 'Indonezija', code: '863' },
  { name: 'Iran', code: '864' },
  { name: 'Irak', code: '865' },
  { name: 'Irska', code: '866' },
  { name: 'Ostrvo Man', code: '867' },
  { name: 'Izrael', code: '868' },
  { name: 'Italija', code: '869' },
  { name: 'Jamajka', code: '870' },
  { name: 'Japan', code: '871' },
  { name: 'Džerzi', code: '872' },
  { name: 'Jordan', code: '873' },
  { name: 'Kazahstan', code: '874' },
  { name: 'Kenija', code: '875' },
  { name: 'Kiribati', code: '876' },
  { name: 'Sjeverna Koreja', code: '877' },
  { name: 'Južna Koreja', code: '878' },
  { name: 'Kuvajt', code: '879' },
  { name: 'Kirgistan', code: '880' },
  { name: 'Laos', code: '881' },
  { name: 'Letonija', code: '882' },
  { name: 'Lebanon', code: '883' },
  { name: 'Lesoto', code: '884' },
  { name: 'Liberija', code: '885' },
  { name: 'Libija', code: '886' },
  { name: 'Lihtenštajn', code: '887' },
  { name: 'Litvanija', code: '888' },
  { name: 'Luksemburg', code: '889' },
  { name: 'Makao (SAR Kina)', code: '890' },
  { name: 'Makedonija', code: '891' },
  { name: 'Madagaskar', code: '892' },
  { name: 'Malavi', code: '893' },
  { name: 'Malezija', code: '894' },
  { name: 'Maldivi', code: '895' },
  { name: 'Mali', code: '896' },
  { name: 'Malta', code: '897' },
  { name: 'Maršalska Ostrva', code: '898' },
  { name: 'Martinik', code: '899' },
  { name: 'Mauritanija', code: '900' },
  { name: 'Mauricijus', code: '901' },
  { name: 'Majote', code: '902' },
  { name: 'Meksiko', code: '903' },
  { name: 'Mikronezija', code: '904' },
  { name: 'Moldavija', code: '905' },
  { name: 'Monako', code: '906' },
  { name: 'Mongolija', code: '907' },
  { name: 'Crna Gora', code: '908' },
  { name: 'Monserat', code: '909' },
  { name: 'Maroko', code: '910' },
  { name: 'Mozambik', code: '911' },
  { name: 'Mjanmar', code: '912' },
  { name: 'Namibija', code: '913' },
  { name: 'Nauru', code: '914' },
  { name: 'Nepal', code: '915' },
  { name: 'Holandija', code: '916' },
  { name: 'Holandski Antili', code: '917' },
  { name: 'Neutralna Zona', code: '918' },
  { name: 'Nova Kaledonija', code: '919' },
  { name: 'Novi Zeland', code: '920' },
  { name: 'Nikaragva', code: '921' },
  { name: 'Niger', code: '922' },
  { name: 'Nigerija', code: '923' },
  { name: 'Niue', code: '924' },
  { name: 'Norfolk Ostrvo', code: '925' },
  { name: 'Sjeverna Marijanska Ostrva', code: '926' },
  { name: 'Norveška', code: '927' },
  { name: 'Oman', code: '928' },
  { name: 'Pakistan', code: '929' },
  { name: 'Palau', code: '930' },
  { name: 'Palestina', code: '931' },
  { name: 'Panama', code: '932' },
  { name: 'Papua Nova Gvineja', code: '933' },
  { name: 'Paragvaj', code: '934' },
  { name: 'Peru', code: '935' },
  { name: 'Filipini', code: '936' },
  { name: 'Pitkernska Ostrva', code: '937' },
  { name: 'Poljska', code: '938' },
  { name: 'Portugal', code: '939' },
  { name: 'Porto Riko', code: '940' },
  { name: 'Katar', code: '941' },
  { name: 'Reunion', code: '942' },
  { name: 'Rumunija', code: '943' },
  { name: 'Rusija', code: '944' },
  { name: 'Ruanda', code: '945' },
  { name: 'Sveti Bartolomej', code: '946' },
  { name: 'Sveta Helena', code: '947' },
  { name: 'Sveti Kits i Nevis', code: '948' },
  { name: 'Sveta Lucija', code: '949' },
  { name: 'Sveti Martin (Francuska)', code: '950' },
  { name: 'Sveti Petar i Mikelon', code: '951' },
  { name: 'Sveti Vinsent i Grenadin', code: '952' },
  { name: 'Samoa', code: '953' },
  { name: 'San Marino', code: '954' },
  { name: 'Sao Tome i Principe', code: '955' },
  { name: 'Saudijska Arabija', code: '956' },
  { name: 'Senegal', code: '957' },
  { name: 'Srbija', code: '958' },
  { name: 'Sejšeli', code: '959' },
  { name: 'Sijera Leone', code: '960' },
  { name: 'Singapur', code: '961' },
  { name: 'Sveti Martin (Holandija)', code: '962' },
  { name: 'Slovačka', code: '963' },
  { name: 'Slovenija', code: '964' },
  { name: 'Solomonska Ostrva', code: '965' },
  { name: 'Somalija', code: '966' },
  { name: 'Južna Afrika', code: '967' },
  { name: 'Južna Džordžija i Južna Sendvička Ostrva', code: '968' },
  { name: 'Južni Sudan', code: '969' },
  { name: 'Španija', code: '970' },
  { name: 'Šri Lanka', code: '971' },
  { name: 'Sudan', code: '972' },
  { name: 'Surinam', code: '973' },
  { name: 'Svalbard i Jan Majen', code: '974' },
  { name: 'Svazilend', code: '975' },
  { name: 'Švedska', code: '976' },
  { name: 'Švajcarska', code: '977' },
  { name: 'Sirija', code: '978' },
  { name: 'Tajvan', code: '979' },
  { name: 'Tadžikistan', code: '980' },
  { name: 'Tanzanija', code: '981' },
  { name: 'Tajland', code: '982' },
  { name: 'Istočni Timor', code: '983' },
  { name: 'Togo', code: '984' },
  { name: 'Tokelau', code: '985' },
  { name: 'Tonga', code: '986' },
  { name: 'Trinidad i Tobago', code: '987' },
  { name: 'Tunis', code: '988' },
  { name: 'Turska', code: '989' },
  { name: 'Turkmenistan', code: '990' },
  { name: 'Ostrva Turks i Kaikos', code: '991' },
  { name: 'Tuvalu', code: '992' },
  { name: 'Uganda', code: '993' },
  { name: 'Ukrajina', code: '994' },
  { name: 'Ujedinjeni Arapski Emirati', code: '995' },
  { name: 'Sjedinjene Američke Države', code: '996' },
  { name: 'Američka Vanjska Ostrva', code: '997' },
  { name: 'Urugvaj', code: '998' },
  { name: 'Uzbekistan', code: '999' },
  { name: 'Vanuatu', code: '1000' },
  { name: 'Venecuela', code: '1001' },
  { name: 'Vijetnam', code: '1002' },
  { name: 'Britanska Djevičanska Ostrva', code: '1003' },
  { name: 'Američka Djevičanska Ostrva', code: '1004' },
  { name: 'Ostrva Valis i Futuna', code: '1005' },
  { name: 'Zapadna Sahara', code: '1006' },
  { name: 'Jemen', code: '1007' },
  { name: 'Zambija', code: '1008' },
  { name: 'Zimbabve', code: '1009' },
  { name: 'Velika Britanija', code: '1010' },
  { name: 'Kosovo', code: '1025' },
];
export const countriesHR = [
  { name: 'AFGANISTAN                         ', code: 'AFG' },
  { name: 'ALBANIJA                           ', code: 'ALB' },
  { name: 'ALŽIR                              ', code: 'DZA' },
  { name: 'AMERIČKA SAMOA                     ', code: 'ASM' },
  { name: 'AMERIČKI DJEVIČANSKI OTOCI         ', code: 'VIR' },
  { name: 'ANDORA                             ', code: 'AND' },
  { name: 'ANGOLA                             ', code: 'AGO' },
  { name: 'ANGUILLA                           ', code: 'AIA' },
  { name: 'ANTARKTIKA                         ', code: 'ATA' },
  { name: 'ANTIGVA I BARBUDA                  ', code: 'ATG' },
  { name: 'ARGENTINA                          ', code: 'ARG' },
  { name: 'ARMENIJA                           ', code: 'ARM' },
  { name: 'ARUBA                              ', code: 'ABW' },
  { name: 'AUSTRALIJA                         ', code: 'AUS' },
  { name: 'AUSTRIJA                           ', code: 'AUT' },
  { name: 'AZERBAJDŽAN                        ', code: 'AZE' },
  { name: 'BAHAMI                             ', code: 'BHS' },
  { name: 'BAHREIN                            ', code: 'BHR' },
  { name: 'BANGLADEŠ                          ', code: 'BGD' },
  { name: 'BARBADOS                           ', code: 'BRB' },
  { name: 'BELGIJA                            ', code: 'BEL' },
  { name: 'BELIZE                             ', code: 'BLZ' },
  { name: 'BENIN                              ', code: 'BEN' },
  { name: 'BERMUDI                            ', code: 'BMU' },
  { name: 'BJELOKOSNA OBALA                   ', code: 'CIV' },
  { name: 'BJELORUSIJA                        ', code: 'BLR' },
  { name: 'BOCVANA                            ', code: 'BWA' },
  { name: 'BOLIVIJA                           ', code: 'BOL' },
  { name: 'BOSNA I HERCEGOVINA                ', code: 'BIH' },
  { name: 'BOŽIĆNI OTOK                       ', code: 'CXR' },
  { name: 'BRAZIL                             ', code: 'BRA' },
  { name: 'BRITANSKI DJEVIČANSKI OTOCI        ', code: 'VGB' },
  { name: 'BRUNEJ                             ', code: 'BRN' },
  { name: 'BUGARSKA                           ', code: 'BGR' },
  { name: 'BURKINA FASO                       ', code: 'BFA' },
  { name: 'BURUNDI                            ', code: 'BDI' },
  { name: 'BUTAN                              ', code: 'BTN' },
  { name: 'CAPE VERDE                         ', code: 'CPV' },
  { name: 'CIPAR                              ', code: 'CYP' },
  { name: 'CRNA GORA                          ', code: 'MNE' },
  { name: 'ČAD                                ', code: 'TCD' },
  { name: 'ČEŠKA                              ', code: 'CZE' },
  { name: 'ČILE                               ', code: 'CHL' },
  { name: 'DANSKA                             ', code: 'DNK' },
  { name: 'DOMINIKA                           ', code: 'DMA' },
  { name: 'DOMINIKANSKA REPUBLIKA             ', code: 'DOM' },
  { name: 'DŽIBUTI                            ', code: 'DJI' },
  { name: 'EGIPAT                             ', code: 'EGY' },
  { name: 'EKVADOR                            ', code: 'ECU' },
  { name: 'EKVATORSKA GVINEJA                 ', code: 'GNQ' },
  { name: 'ERITREJA                           ', code: 'ERI' },
  { name: 'ESTONIJA                           ', code: 'EST' },
  { name: 'ETIOPIJA                           ', code: 'ETH' },
  { name: 'FALKLANDI (MALVINI)                ', code: 'FLK' },
  { name: 'FEROJSKI (OVČJI) OTOCI             ', code: 'FRO' },
  { name: 'FIDŽI                              ', code: 'FJI' },
  { name: 'FILIPINI                           ', code: 'PHL' },
  { name: 'FINSKA                             ', code: 'FIN' },
  { name: 'FRANCUSKA                          ', code: 'FRA' },
  { name: 'FRANCUSKA GVAJANA                  ', code: 'GUF' },
  { name: 'FRANCUSKA POLINEZIJA               ', code: 'PYF' },
  { name: 'FRANCUSKI JUŽNI TERITORIJI         ', code: 'ATF' },
  { name: 'GABON                              ', code: 'GAB' },
  { name: 'GAMBIJA                            ', code: 'GMB' },
  { name: 'GANA                               ', code: 'GHA' },
  { name: 'GIBRALTAR                          ', code: 'GIB' },
  { name: 'GRČKA                              ', code: 'GRC' },
  { name: 'GRENADA                            ', code: 'GRD' },
  { name: 'GRENLAND                           ', code: 'GRL' },
  { name: 'GRUZIJA                            ', code: 'GEO' },
  { name: 'GUADELOUPE                         ', code: 'GLP' },
  { name: 'GUAM                               ', code: 'GUM' },
  { name: 'GUERNSEY                           ', code: 'GGY' },
  { name: 'GVAJANA                            ', code: 'GUY' },
  { name: 'GVATEMALA                          ', code: 'GTM' },
  { name: 'GVINEJA                            ', code: 'GIN' },
  { name: 'GVINEJA BISAU                      ', code: 'GNB' },
  { name: 'HAITI                              ', code: 'HTI' },
  { name: 'HONDURAS                           ', code: 'HND' },
  { name: 'HONG KONG                          ', code: 'HKG' },
  { name: 'HRVATSKA                           ', code: 'HRV' },
  { name: 'INDIJA                             ', code: 'IND' },
  { name: 'INDONEZIJA                         ', code: 'IDN' },
  { name: 'IRAK                               ', code: 'IRQ' },
  { name: 'IRAN                               ', code: 'IRN' },
  { name: 'IRSKA                              ', code: 'IRL' },
  { name: 'ISLAND                             ', code: 'ISL' },
  { name: 'ITALIJA                            ', code: 'ITA' },
  { name: 'IZRAEL                             ', code: 'ISR' },
  { name: 'JAMAJKA                            ', code: 'JAM' },
  { name: 'JAPAN                              ', code: 'JPN' },
  { name: 'JEMEN                              ', code: 'YEM' },
  { name: 'JERSEY                             ', code: 'JEY' },
  { name: 'JORDAN                             ', code: 'JOR' },
  { name: 'JUŽNOAFRIČKA                       ', code: 'ZAF' },
  { name: 'KAJMANSKI OTOCI                    ', code: 'CYM' },
  { name: 'KAMBODŽA                           ', code: 'KHM' },
  { name: 'KAMERUN                            ', code: 'CMR' },
  { name: 'KANADA                             ', code: 'CAN' },
  { name: 'KATAR                              ', code: 'QAT' },
  { name: 'KAZAHSTAN                          ', code: 'KAZ' },
  { name: 'KENIJA                             ', code: 'KEN' },
  { name: 'KINA                               ', code: 'CHN' },
  { name: 'KIRGISTAN                          ', code: 'KGZ' },
  { name: 'KIRIBATI                           ', code: 'KIR' },
  { name: 'KOKOSOVI OTOCI                     ', code: 'CCK' },
  { name: 'KOLUMBIJA                          ', code: 'COL' },
  { name: 'KOMORI                             ', code: 'COM' },
  { name: 'KONGO                              ', code: 'COG' },
  { name: 'KONGO, DEMOKRATSKA REPUBLIKA       ', code: 'COD' },
  { name: 'KOREJA, SJEVERNA                   ', code: 'PRK' },
  { name: 'KOREJA, JUŽNA                      ', code: 'KOR' },
  { name: 'KOSOVO                             ', code: 'XKX' },
  { name: 'KOSTARIKA                          ', code: 'CRI' },
  { name: 'KUBA                               ', code: 'CUB' },
  { name: 'KUKOVI OTOCI                       ', code: 'COK' },
  { name: 'KUVAJT                             ', code: 'KWT' },
  { name: 'LAOS                               ', code: 'LAO' },
  { name: 'LESOTO                             ', code: 'LSO' },
  { name: 'LETONIJA                           ', code: 'LVA' },
  { name: 'LIBANON                            ', code: 'LBN' },
  { name: 'LIBERIJA                           ', code: 'LBR' },
  { name: 'LIBIJA                             ', code: 'LBY' },
  { name: 'LIHTENŠTAJN                        ', code: 'LIE' },
  { name: 'LITVA                              ', code: 'LTU' },
  { name: 'LUKSEMBURG                         ', code: 'LUX' },
  { name: 'MADAGASKAR                         ', code: 'MDG' },
  { name: 'MADŽARSKA                          ', code: 'HUN' },
  { name: 'MAKAO                              ', code: 'MAC' },
  { name: 'MAKEDONIJA                         ', code: 'MKD' },
  { name: 'MALAVI                             ', code: 'MWI' },
  { name: 'MALDIVI                            ', code: 'MDV' },
  { name: 'MALEZIJA                           ', code: 'MYS' },
  { name: 'MALI                               ', code: 'MLI' },
  { name: 'MALTA                              ', code: 'MLT' },
  { name: 'MAROKO                             ', code: 'MAR' },
  { name: 'MARŠALOVI OTOCI                    ', code: 'MHL' },
  { name: 'MARTINIQUE                         ', code: 'MTQ' },
  { name: 'MAURICIJUS                         ', code: 'MUS' },
  { name: 'MAURITANIJA                        ', code: 'MRT' },
  { name: 'MAYOTTE                            ', code: 'MYT' },
  { name: 'MEKSIKO                            ', code: 'MEX' },
  { name: 'MIJANMAR                           ', code: 'MMR' },
  { name: 'MIKRONEZIJA                        ', code: 'FSM' },
  { name: 'MOLDAVIJA                          ', code: 'MDA' },
  { name: 'MONAKO                             ', code: 'MCO' },
  { name: 'MONGOLIJA                          ', code: 'MNG' },
  { name: 'MONTSERRAT                         ', code: 'MSR' },
  { name: 'MOZAMBIK                           ', code: 'MOZ' },
  { name: 'NAMIBIJA                           ', code: 'NAM' },
  { name: 'NAURU                              ', code: 'NRU' },
  { name: 'NEPAL                              ', code: 'NPL' },
  { name: 'NIGER                              ', code: 'NER' },
  { name: 'NIGERIJA                           ', code: 'NGA' },
  { name: 'NIKARAGVA                          ', code: 'NIC' },
  { name: 'NIUE                               ', code: 'NIU' },
  { name: 'NIZOZEMSKA                         ', code: 'NLD' },
  { name: 'NORVEŠKA                           ', code: 'NOR' },
  { name: 'NOVA KALEDONIJA                    ', code: 'NCL' },
  { name: 'NOVI ZELAND                        ', code: 'NZL' },
  { name: 'NJEMAČKA                           ', code: 'DEU' },
  { name: 'OMAN                               ', code: 'OMN' },
  { name: 'OTOCI TURKS I CAICOS               ', code: 'TCA' },
  { name: 'OTOK BOUVET                        ', code: 'BVT' },
  { name: 'OTOK HEARD I OTOCI MCDONALD        ', code: 'HMD' },
  { name: 'OTOK MAN                           ', code: 'IMN' },
  { name: 'OTOK NORFOLK                       ', code: 'NFK' },
  { name: 'PAKISTAN                           ', code: 'PAK' },
  { name: 'PALAU                              ', code: 'PLW' },
  { name: 'PALESTINSKO PODRUČJE               ', code: 'PSE' },
  { name: 'PANAMA                             ', code: 'PAN' },
  { name: 'PAPUA NOVA GVINEJA                 ', code: 'PNG' },
  { name: 'PARAGVAJ                           ', code: 'PRY' },
  { name: 'PERU                               ', code: 'PER' },
  { name: 'PITCAIRN                           ', code: 'PCN' },
  { name: 'POLJSKA                            ', code: 'POL' },
  { name: 'PORTORIKO                          ', code: 'PRI' },
  { name: 'PORTUGAL                           ', code: 'PRT' },
  { name: 'RÉUNION                            ', code: 'REU' },
  { name: 'RUANDA                             ', code: 'RWA' },
  { name: 'RUMUNJSKA                          ', code: 'ROU' },
  { name: 'RUSIJA                             ', code: 'RUS' },
  { name: 'SAD                                ', code: 'USA' },
  { name: 'SALVADOR                           ', code: 'SLV' },
  { name: 'SAMOA                              ', code: 'WSM' },
  { name: 'SAN MARINO                         ', code: 'SMR' },
  { name: 'SAUDIJSKA ARABIJA                  ', code: 'SAU' },
  { name: 'SEJŠELI                            ', code: 'SYC' },
  { name: 'SENEGAL                            ', code: 'SEN' },
  { name: 'SIJERA LEONE                       ', code: 'SLE' },
  { name: 'SINGAPUR                           ', code: 'SGP' },
  { name: 'SIRIJA                             ', code: 'SYR' },
  { name: 'SJEVERNI MARIJANSKI OTOCI          ', code: 'MNP' },
  { name: 'SLOVAČKA                           ', code: 'SVK' },
  { name: 'SLOVENIJA                          ', code: 'SVN' },
  { name: 'SOLOMONSKI OTOCI                   ', code: 'SLB' },
  { name: 'SOMALIJA                           ', code: 'SOM' },
  { name: 'SRBIJA                             ', code: 'SRB' },
  { name: 'SREDNJOAFRIČKA REPUBLIKA           ', code: 'CAF' },
  { name: 'SUDAN                              ', code: 'SDN' },
  { name: 'SURINAM                            ', code: 'SUR' },
  { name: 'SVALBARD I JAN MAYEN               ', code: 'SJM' },
  { name: 'SVAZI                              ', code: 'SWZ' },
  { name: 'SVETA HELENA, ASCENSION I TRISTAN  ', code: 'SHN' },
  { name: 'SVETA LUCIJA                       ', code: 'LCA' },
  { name: 'SVETI BARTOLOMEJ                   ', code: 'BLM' },
  { name: 'VATIKAN, SVETA STOLICA             ', code: 'VAT' },
  { name: 'SVETI KRISTOFOR I NEVIS            ', code: 'KNA' },
  { name: 'SVETI MARTIN                       ', code: 'MAF' },
  { name: 'SVETI PETAR I MIKELON              ', code: 'SPM' },
  { name: 'SVETI TOMA I PRINSIPE              ', code: 'STP' },
  { name: 'SVETI VINCENT I GRENADINI          ', code: 'VCT' },
  { name: 'ŠPANJOLSKA                         ', code: 'ESP' },
  { name: 'ŠRI LANKA                          ', code: 'LKA' },
  { name: 'ŠVEDSKA                            ', code: 'SWE' },
  { name: 'ŠVICARSKA                          ', code: 'CHE' },
  { name: 'TADŽIKISTAN                        ', code: 'TJK' },
  { name: 'TAJLAND                            ', code: 'THA' },
  { name: 'TAJVAN, KINESKI                    ', code: 'TWN' },
  { name: 'TANZANIJA                          ', code: 'TZA' },
  { name: 'TIMOR LESTE                        ', code: 'TLS' },
  { name: 'TOGO                               ', code: 'TGO' },
  { name: 'TOKELAU                            ', code: 'TKL' },
  { name: 'TONGA                              ', code: 'TON' },
  { name: 'TRINIDAD I TOBAGO                  ', code: 'TTO' },
  { name: 'TUNIS                              ', code: 'TUN' },
  { name: 'TURKMENISTAN                       ', code: 'TKM' },
  { name: 'TURSKA                             ', code: 'TUR' },
  { name: 'TUVALU                             ', code: 'TUV' },
  { name: 'UGANDA                             ', code: 'UGA' },
  { name: 'UJEDINJENI ARAPSKI EMIRATI         ', code: 'ARE' },
  { name: 'UKRAJINA                           ', code: 'UKR' },
  { name: 'URUGVAJ                            ', code: 'URY' },
  { name: 'UZBEKISTAN                         ', code: 'UZB' },
  { name: 'VANUATU                            ', code: 'VUT' },
  { name: 'VELIKA BRITANIJA                   ', code: 'GBR' },
  { name: 'VENEZUELA                          ', code: 'VEN' },
  { name: 'VIJETNAM                           ', code: 'VNM' },
  { name: 'WALLIS I FUTUNA                    ', code: 'WLF' },
  { name: 'ZAMBIJA                            ', code: 'ZMB' },
  { name: 'ZAPADNA SAHARA                     ', code: 'ESH' },
  { name: 'ZIMBABVE                           ', code: 'ZWE' },
];

export const countriesEN = [
  { name: 'AFGHANISTAN', code: 'AFG' },
  { name: 'ALBANIA', code: 'ALB' },
  { name: 'ALGERIA', code: 'DZA' },
  { name: 'AMERICAN SAMOA', code: 'ASM' },
  { name: 'AMERICAN VIRGIN ISLANDS', code: 'VIR' },
  { name: 'ANDORRA', code: 'AND' },
  { name: 'ANGOLA', code: 'AGO' },
  { name: 'ANGUILLA', code: 'AIA' },
  { name: 'ANTARCTICA', code: 'ATA' },
  { name: 'ANTIGUA AND BARBUDA', code: 'ATG' },
  { name: 'ARGENTINA', code: 'ARG' },
  { name: 'ARMENIA', code: 'ARM' },
  { name: 'ARUBA', code: 'ABW' },
  { name: 'AUSTRALIA', code: 'AUS' },
  { name: 'AUSTRIA', code: 'AUT' },
  { name: 'AZERBAIJAN', code: 'AZE' },
  { name: 'BAHAMAS', code: 'BHS' },
  { name: 'BAHRAIN', code: 'BHR' },
  { name: 'BANGLADESH', code: 'BGD' },
  { name: 'BARBADOS', code: 'BRB' },
  { name: 'BELARUS', code: 'BLR' },
  { name: 'BELGIUM', code: 'BEL' },
  { name: 'BELIZE', code: 'BLZ' },
  { name: 'BENIN', code: 'BEN' },
  { name: 'BERMUDA', code: 'BMU' },
  { name: 'BOLIVIA', code: 'BOL' },
  { name: 'BOSNIA AND HERZEGOVINA', code: 'BIH' },
  { name: 'BOTSWANA', code: 'BWA' },
  { name: 'BOUVET ISLAND', code: 'BVT' },
  { name: 'BRAZIL', code: 'BRA' },
  { name: 'BRITISH VIRGIN ISLANDS', code: 'VGB' },
  { name: 'BRUNEI', code: 'BRN' },
  { name: 'BULGARIA', code: 'BGR' },
  { name: 'BURKINA FASO', code: 'BFA' },
  { name: 'BURUNDI', code: 'BDI' },
  { name: 'BUTANE', code: 'BTN' },
  { name: 'CAMBODIA', code: 'KHM' },
  { name: 'CAMEROON', code: 'CMR' },
  { name: 'CANADA', code: 'CAN' },
  { name: 'CAPE VERDE', code: 'CPV' },
  { name: 'QATAR', code: 'QAT' },
  { name: 'CAYMAN ISLANDS', code: 'CYM' },
  { name: 'CENTRAL AFRICAN REPUBLIC', code: 'CAF' },
  { name: 'CHAD', code: 'TCD' },
  { name: 'CHAMBER', code: 'COM' },
  { name: 'CHILE', code: 'CHL' },
  { name: 'CHINA', code: 'CHN' },
  { name: 'CHRISTMAS ISLAND', code: 'CXR' },
  { name: 'COCONUT ISLANDS', code: 'CCK' },
  { name: 'COLOMBIA', code: 'COL' },
  { name: 'CONGO', code: 'COG' },
  { name: 'CONGO, DEMOCRATIC REPUBLIC', code: 'COD' },
  { name: 'COSTA RICA', code: 'CRI' },
  { name: 'CUBA', code: 'CUB' },
  { name: 'CROATIA', code: 'HRV' },
  { name: 'CYPRUS', code: 'CYP' },
  { name: 'CZECH REPUBLIC', code: 'CZE' },
  { name: 'DENMARK', code: 'DNK' },
  { name: 'Djibouti', code: 'DJI' },
  { name: 'DOMINICA', code: 'DMA' },
  { name: 'DOMINICAN REPUBLIC', code: 'DOM' },
  { name: 'ECUADOR', code: 'ECU' },
  { name: 'EGYPT', code: 'EGY' },
  { name: 'EQUATORIAL GUINEA', code: 'GNQ' },
  { name: 'ERITREA', code: 'ERI' },
  { name: 'ESTONIA', code: 'EST' },
  { name: 'ETHIOPIA', code: 'ETH' },
  { name: 'FAIRY (SHEEP) ISLANDS', code: 'FRO' },
  { name: 'FALKLANDS (MALVINI)', code: 'FLK' },
  { name: 'FIJI', code: 'FJI' },
  { name: 'FINLAND', code: 'FIN' },
  { name: 'FRANCE', code: 'FRA' },
  { name: 'FRENCH GUYANA', code: 'GUF' },
  { name: 'FRENCH POLYNESIA', code: 'PYF' },
  { name: 'FRENCH SOUTHERN TERRITORIES', code: 'ATF' },
  { name: 'GABON', code: 'GAB' },
  { name: 'GAMBIA', code: 'GMB' },
  { name: 'GEORGIA', code: 'GEO' },
  { name: 'GERMANY', code: 'DEU' },
  { name: 'GHANA', code: 'GHA' },
  { name: 'GIBRALTAR', code: 'GIB' },
  { name: 'GREAT BRITAIN', code: 'GBR' },
  { name: 'GREECE', code: 'GRC' },
  { name: 'GREENLAND', code: 'GRL' },
  { name: 'GRENADE', code: 'GRD' },
  { name: 'GUADELOUPE', code: 'GLP' },
  { name: 'GUAM', code: 'GUM' },
  { name: 'GUATEMALA', code: 'GTM' },
  { name: 'GUERNSEY', code: 'GGY' },
  { name: 'GUINEA', code: 'GIN' },
  { name: 'GUINEA BISAU', code: 'GNB' },
  { name: 'GUYANA', code: 'GUY' },
  { name: 'HAITI', code: 'HTI' },
  { name: 'HEARD ISLAND AND MCDONALD ISLANDS', code: 'HMD' },
  { name: 'HONDURAS', code: 'HND' },
  { name: 'HONG KONG', code: 'HKG' },
  { name: 'HOOK ISLANDS', code: 'COK' },
  { name: 'HUNGARY', code: 'HUN' },
  { name: 'ICELAND', code: 'ISL' },
  { name: 'INDIA', code: 'IND' },
  { name: 'INDONESIA', code: 'IDN' },
  { name: 'IRAN', code: 'IRN' },
  { name: 'IRAQ', code: 'IRQ' },
  { name: 'IRELAND', code: 'IRL' },
  { name: 'ISLAND OF MAN', code: 'IMN' },
  { name: 'ISRAEL', code: 'ISR' },
  { name: 'ITALY', code: 'ITA' },
  { name: 'Ivory Coast', code: 'CIV' },
  { name: 'JAMAICA', code: 'JAM' },
  { name: 'JAPAN', code: 'JPN' },
  { name: 'JERSEY', code: 'JEY' },
  { name: 'JORDAN', code: 'JOR' },
  { name: 'KAZAKHSTAN', code: 'KAZ' },
  { name: 'KENYA', code: 'KEN' },
  { name: 'KIRIBATI', code: 'KIR' },
  { name: 'KOREA, NORTH', code: 'PRK' },
  { name: 'KOREA, SOUTH', code: 'KOR' },
  { name: 'KOSOVO', code: 'XKX' },
  { name: 'KUWAIT', code: 'KWT' },
  { name: 'KYRGYZSTAN', code: 'KGZ' },
  { name: 'LAOS', code: 'LAO' },
  { name: 'LATVIA', code: 'LVA' },
  { name: 'LEBANON', code: 'LBN' },
  { name: 'LESOTHO', code: 'LSO' },
  { name: 'LIBERIA', code: 'LBR' },
  { name: 'LIBYA', code: 'LBY' },
  { name: 'LIECHTENSTEIN', code: 'LIE' },
  { name: 'LITHUANIA', code: 'LTU' },
  { name: 'LITTLE', code: 'MLI' },
  { name: 'LUXEMBOURG', code: 'LUX' },
  { name: 'MACEDONIA', code: 'MKD' },
  { name: 'MADAGASCAR', code: 'MDG' },
  { name: 'MAKAO', code: 'MAC' },
  { name: 'MALAWI', code: 'MWI' },
  { name: 'MALAYSIA', code: 'MYS' },
  { name: 'MALDIVES', code: 'MDV' },
  { name: 'MALTA', code: 'MLT' },
  { name: 'MARSHAL ISLANDS', code: 'MHL' },
  { name: 'MARTINIQUE', code: 'MTQ' },
  { name: 'MAURITANIA', code: 'MRT' },
  { name: 'MAURITIUS', code: 'MUS' },
  { name: 'MAYOTTE', code: 'MYT' },
  { name: 'MEXICO', code: 'MEX' },
  { name: 'MICRONESIA', code: 'FSM' },
  { name: 'MOLDOVA', code: 'MDA' },
  { name: 'MONACO', code: 'MCO' },
  { name: 'MONGOLIA', code: 'MNG' },
  { name: 'MONTENEGRO', code: 'MNE' },
  { name: 'MONTSERRAT', code: 'MSR' },
  { name: 'MOROCCO', code: 'MAR' },
  { name: 'MOZAMBIQUE', code: 'MOZ' },
  { name: 'MYANMAR', code: 'MMR' },
  { name: 'NAMIBIA', code: 'NAM' },
  { name: 'NAURU', code: 'NRU' },
  { name: 'NEPAL', code: 'NPL' },
  { name: 'NETHERLANDS', code: 'NLD' },
  { name: 'NEW', code: 'NIU' },
  { name: 'NEW CALEDONIA', code: 'NCL' },
  { name: 'NEW ZEALAND', code: 'NZL' },
  { name: 'NICARAGUA', code: 'NIC' },
  { name: 'NIGER', code: 'NER' },
  { name: 'NIGERIA', code: 'NGA' },
  { name: 'NORFOLK ISLAND', code: 'NFK' },
  { name: 'NORTHERN MARIAN ISLANDS', code: 'MNP' },
  { name: 'NORWAY', code: 'NOR' },
  { name: 'OMAN', code: 'OMN' },
  { name: 'PAKISTAN', code: 'PAK' },
  { name: 'PALAU', code: 'PLW' },
  { name: 'PALESTINIAN AREA', code: 'PSE' },
  { name: 'PANAMA', code: 'PAN' },
  { name: 'PAPUA NEW GUINEA', code: 'PNG' },
  { name: 'PARAGUAY', code: 'PRY' },
  { name: 'PERU', code: 'PER' },
  { name: 'PHILIPPINES', code: 'PHL' },
  { name: 'PITCAIRN', code: 'PCN' },
  { name: 'POLAND', code: 'POL' },
  { name: 'PORTUGAL', code: 'PRT' },
  { name: 'PUERTO RICO', code: 'PRI' },
  { name: 'REUNION', code: 'REU' },
  { name: 'ROMANIA', code: 'ROU' },
  { name: 'RUSSIA', code: 'RUS' },
  { name: 'RWANDA', code: 'RWA' },
  { name: 'SAINT BARTHOLOMEW', code: 'BLM' },
  { name: 'SAINT CHRISTOPHER AND NEVIS', code: 'KNA' },
  { name: 'SAINT HELENA, ASCENSION AND TRISTAN', code: 'SHN' },
  { name: 'SAINT LUCIA', code: 'LCA' },
  { name: 'SAINT MARTIN', code: 'MAF' },
  { name: 'SAINT PETER AND MICHELON', code: 'SPM' },
  { name: 'SAINT TOMA AND PRINCIPE', code: 'STP' },
  { name: 'SAINT VINCENT AND THE Grenadines', code: 'VCT' },
  { name: 'SALVADOR', code: 'SLV' },
  { name: 'SAMOA', code: 'WSM' },
  { name: 'SAN MARINO', code: 'SMR' },
  { name: 'SAUDI ARABIA', code: 'SAU' },
  { name: 'SENEGAL', code: 'SEN' },
  { name: 'SERBIA', code: 'SRB' },
  { name: 'SEYCHELLES', code: 'SYC' },
  { name: 'SIJERA LEONE', code: 'SLE' },
  { name: 'SINGAPORE', code: 'SGP' },
  { name: 'SLOVAKIA', code: 'SVK' },
  { name: 'SLOVENIA', code: 'SVN' },
  { name: 'SOLOMON ISLANDS', code: 'SLB' },
  { name: 'SOMALIA', code: 'SOM' },
  { name: 'SOUTH AFRICA', code: 'ZAF' },
  { name: 'SPAIN', code: 'ESP' },
  { name: 'SRI LANKA', code: 'LKA' },
  { name: 'SUDAN', code: 'SDN' },
  { name: 'SURINAM', code: 'SUR' },
  { name: 'SVALBARD AND JAN MAYEN', code: 'SJM' },
  { name: 'SVAZI', code: 'SWZ' },
  { name: 'SWEDEN', code: 'SWE' },
  { name: 'SWITZERLAND', code: 'CHE' },
  { name: 'SYRIA', code: 'SYR' },
  { name: 'TAIWAN, CHINESE', code: 'TWN' },
  { name: 'TAJIKISTAN', code: 'TJK' },
  { name: 'TANZANIA', code: 'TZA' },
  { name: 'THAILAND', code: 'THA' },
  { name: 'TIMOR LESTE', code: 'TLS' },
  { name: 'TOGO', code: 'TGO' },
  { name: 'TOKELAU', code: 'TKL' },
  { name: 'TONGA', code: 'TON' },
  { name: 'TRINIDAD AND TOBAGO', code: 'TTO' },
  { name: 'TUNISIA', code: 'TUN' },
  { name: 'TURKEY', code: 'TUR' },
  { name: 'TURKMENISTAN', code: 'TKM' },
  { name: 'TURKS AND CAICOS ISLANDS', code: 'TCA' },
  { name: 'TUVALU', code: 'TUV' },
  { name: 'UGANDA', code: 'UGA' },
  { name: 'UKRAINE', code: 'UKR' },
  { name: 'UNITED ARAB EMIRATES', code: 'ARE' },
  { name: 'UNITED STATES OF AMERICA', code: 'USA' },
  { name: 'URUGUAY', code: 'URY' },
  { name: 'UZBEKISTAN', code: 'UZB' },
  { name: 'VANUATU', code: 'VUT' },
  { name: 'VATICAN, HOLY SEE', code: 'VAT' },
  { name: 'VENEZUELA', code: 'VEN' },
  { name: 'VIETNAM', code: 'VNM' },
  { name: 'WALLIS AND FUTUNA', code: 'WLF' },
  { name: 'WESTERN SAHARA', code: 'ESH' },
  { name: 'YEMEN', code: 'YEM' },
  { name: 'ZAMBIA', code: 'ZMB' },
  { name: 'ZIMBABWE', code: 'ZWE' },
];
